import React, { FC } from 'react'

import { IconTopicsProps } from './IconTopics.types'
import * as Styled from './styles/IconTopics.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTopics: FC<IconTopicsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTopicsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconTopicsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M80 8C35.89 8 0 35.87 0 70.12c0 20 12.24 38.58 32.92 50.25a33.54 33.54 0 0 1-15.31 17.9 4 4 0 0 0 1.06 7.4 54 54 0 0 0 11.89 1.24c14.38 0 29.71-4.7 40-9.59l.27-.14 8.63-4.94H80c44.11 0 80-27.87 80-62.12S124.11 8 80 8zm0 116.24h-1.62a4 4 0 0 0-2 .53L67 130.16c-9.6 4.55-23.82 8.89-36.87 8.77a41.54 41.54 0 0 0 11.18-18.42v-.12l.26-1a4 4 0 0 0-2.4-4.73C19.65 104.52 8 87.88 8 70.12 8 40.28 40.3 16 80 16s72 24.28 72 54.12-32.3 54.12-72 54.12z' />
        <circle cx='80' cy='72' r='8' />
        <circle cx='112' cy='72' r='8' />
        <circle cx='48' cy='72' r='8' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTopics
